var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3684 15C12.3684 12.9381 9.82351 11.2667 6.68421 11.2667C3.54491 11.2667 1 12.9381 1 15M16.1579 12.2V9.4M16.1579 9.4V6.6M16.1579 9.4H13.3158M16.1579 9.4H19M6.68421 8.46667C4.59134 8.46667 2.89474 6.7952 2.89474 4.73333C2.89474 2.67147 4.59134 1 6.68421 1C8.77708 1 10.4737 2.67147 10.4737 4.73333C10.4737 6.7952 8.77708 8.46667 6.68421 8.46667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewUser);
export default __webpack_public_path__ + "static/media/AddNewUser.800b7ccf62eac0130d8b556ada1514b4.svg";
export { ForwardRef as ReactComponent };